import React, { PropsWithChildren, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { UpdateThemeContext } from './contexts';
import { Theme } from './contexts/theme';
import { darkTheme } from './constants/theme';

export function ThemeContextProvider({ defaultTheme, children }: PropsWithChildren<{ defaultTheme: Theme }>) {
    const [theme, setTheme] = useState(defaultTheme);

    useEffect(() => {
        document.documentElement.classList.toggle('dark', theme === darkTheme);
    }, [theme]);

    return (
        <UpdateThemeContext.Provider value={{ setTheme }}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </UpdateThemeContext.Provider>
    );
}
